<template>
  <BContainer
    v-if="user"
    fluid
  >
    <div class="d-flex flex-column flex-md-row justify-content-md-between mb-0 pb-0">
      <div
        class="order-2 order-md-1"
      >
        <BButton
          size="sm"
          variant="primary"
          @click.prevent="createRequest"
        >
          Create Withdrawal
        </BButton>
      </div>
      <div
        class="order-1 order-md-2 align-self-end mb-3 mb-md-0"
      >
        <BBreadcrumb
          v-if="$route.meta.breadcrumb"
          :items="$route.meta.breadcrumb || []"
        />
      </div>
    </div>

    <BTabs
      v-model="currentTabIndex"
      active-nav-item-class="font-weight-bold text-uppercase text-primary"
      class="mt-3"
    >
      <BTab>
        <template #title>
          <i :class="iconState('fa-file-circle-info', currentTabIndex === 0)" /> Pendings
        </template>
        <RequestPending
          ref="srPending"
          :tab-index="currentTabIndex"
          @show="showRequestPreview"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-file-circle-question', currentTabIndex === 1)" /> Drafts
        </template>
        <RequestDraft
          ref="srDraft"
          :tab-index="currentTabIndex"
          @show="showRequest"
        />
      </BTab>

      <BTab>
        <template #title>
          <i :class="iconState('fa-clock-rotate-left', currentTabIndex === 2)" /> Histories
        </template>
        <RequestHistory
          ref="srHistory"
          :tab-index="currentTabIndex"
          @show="showRequestPreview"
          @edit="showRequest"
        />
      </BTab>
    </BTabs>

    <BModal
      id="modalRequest"
      size="xl"
      scrollable
      centered
      hide-header
      no-close-on-esc
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="px-0 py-2">
          <template #title>
            <div class="text-md-nowrap">
              <i
                :class="['fa-lg fad fa-list-tree', {
                  'text-danger fat fa-shake': vTabStockRequest() || vTabProducts()
                }]"
              />
              <b
                :class="['is-tab-active ml-1', {
                  'text-danger': vTabStockRequest() || vTabProducts()
                }]"
              >
                Products
              </b>
            </div>
          </template>

          <BRow
            class="mx-0 mt-1 mb-0"
          >
            <BCol
              cols="12"
            >
              <ValidationObserver
                ref="formStockRequest"
              >
                <form
                  role="form"
                  novalidate
                  @submit.prevent
                >
                  <BRow>
                    <BCol
                      cols="12"
                      md="3"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        vid="withdrawal_type"
                        name="withdrawal type"
                        rules="required"
                      >
                        <BFormGroup
                          label="Withdrawal Type"
                          label-for="fWithdrawalType"
                          label-class="font-weight-bolder"
                        >
                          <BFormSelect
                            id="fWithdrawalType"
                            v-model="selected.locationType"
                            :options="options.withdrawalTypes"
                            :state="(errors.length > 0 ? false : null)"
                          >
                            <template #first>
                              <BFormSelectOption
                                value=""
                                disabled
                              >
                                -- select type here --
                              </BFormSelectOption>
                            </template>
                          </BFormSelect>
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </BFormGroup>
                      </ValidationProvider>
                    </BCol>

                    <BCol
                      v-if="stockRequest.headers.withdrawal_type === 'Supplier'"
                      cols="12"
                      md="5"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        vid="headers.supplier"
                        name="supplier"
                        rules="required"
                      >
                        <BFormGroup
                          label="Withdraw From"
                          label-for="fSupplier"
                          label-class="font-weight-bolder"
                          class="mb-2"
                        >
                          <v-select
                            v-model="selected.supplier"
                            input-id="fSupplier"
                            label="supplier_name"
                            placeholder="search supplier here"
                            :options="options.suppliers"
                            :class="{ 'is-invalid': errors.length > 0 }"
                            :disabled="fetching.suppliers"
                            :loading="fetching.suppliers"
                            @search="searchSuppliers"
                          >
                            <template #no-options="">
                              no available supplier
                            </template>
                          </v-select>
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </BFormGroup>
                      </ValidationProvider>
                    </BCol>

                    <BCol
                      v-else-if="stockRequest.headers.withdrawal_type === 'Warehouse'"
                      cols="12"
                      md="5"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        vid="headers.destination"
                        name="location"
                        rules="required"
                      >
                        <BFormGroup
                          label="Withdraw From"
                          label-for="fDestination"
                          label-class="font-weight-bolder"
                          class="mb-2"
                        >
                          <v-select
                            v-model="selected.destination"
                            input-id="fDestination"
                            label="location_name"
                            placeholder="search warehouse here"
                            :options="options.destinations"
                            :class="{ 'is-invalid': errors.length > 0 }"
                            :disabled="fetching.destinations"
                            :loading="fetching.destinations"
                            @search="searchDestinations"
                          >
                            <template #no-options="">
                              no available warehouse
                            </template>
                          </v-select>
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </BFormGroup>
                      </ValidationProvider>
                    </BCol>

                    <BCol
                      v-else
                      cols="12"
                      md="5"
                    >
                      <ValidationProvider
                        v-slot="{ errors }"
                        vid="headers.destination"
                        name="location"
                        rules="required"
                      >
                        <BFormGroup
                          label="Withdraw From"
                          label-for="fDestination"
                          label-class="font-weight-bolder"
                          class="mb-2"
                        >
                          <v-select
                            v-model="selected.destination"
                            input-id="fDestination"
                            label="location_name"
                            placeholder="search warehouse here"
                            :options="options.destinations"
                            :class="{ 'is-invalid': errors.length > 0 }"
                            :disabled="fetching.destinations"
                            :loading="fetching.destinations"
                            @search="searchDestinations"
                          >
                            <template #no-options="">
                              no available warehouse
                            </template>
                          </v-select>
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </BFormGroup>
                      </ValidationProvider>
                    </BCol>
                  </BRow>
                </form>
              </ValidationObserver>
            </BCol>

            <BCol
              cols="12"
            >
              <ValidationObserver
                ref="formProducts"
              >
                <POTable
                  ref="componentProducts"
                  :use-stocks="true"
                  :details="stockRequest.details"
                  :options="options.products"
                >
                  <template #table-actions>
                    <BButton
                      v-b-tooltip.hover.bottomright="{ variant: 'primary' }"
                      title="Check Stocks"
                      size="sm"
                      variant="outline-primary"
                      class="text-nowrap"
                      :disabled="fetching.stocks"
                      @click.prevent="checkStocks"
                    >
                      <i
                        :class="['fa-lg fad fa-arrows-rotate pr-0', { 'fa-spin': fetching.stocks }]"
                      />
                    </BButton>
                  </template>
                </POTable>
              </ValidationObserver>
            </BCol>
          </BRow>
        </BTab>
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i
                :class="['fa-lg fad fa-file-lines', {
                  'text-danger fat fa-shake': vTabWithdrawalDetails()
                }]"
              />
              <b
                :class="['is-tab-active ml-1', {
                  'text-danger': vTabWithdrawalDetails()
                }]"
              >
                Withdrawal Details
              </b>
            </div>
          </template>

          <BRow
            class="mx-0 mt-1 mb-0"
          >
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <ValidationObserver
                ref="formWithdrawal"
              >
                <BRow>

                  <BCol
                    cols="12"
                    md="3"
                    class="px-1 px-md-2"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="pickup_details.date"
                      name="date"
                      rules="required"
                    >
                      <BFormGroup
                        label="Pick-Up Date"
                        label-for="fPickUpDate"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fPickUpDate"
                          v-model="stockRequest.pickup_details.date"
                          type="date"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="busy"
                        />
                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                    md="6"
                    class="px-1 px-md-2"
                  >
                    <BFormGroup
                      label="Is 3PL?"
                      label-for="fPickUpDate"
                      label-class="font-weight-bolder"
                      class="mb-2 d-flex flex-column justify-content-center"
                    >
                      <BFormCheckbox
                        id="is_active"
                        v-model="stockRequest.pickup_details.is_3pl"
                        switch
                        value="1"
                        name="is_active"
                        unchecked-value="0"
                        class="mt-1"
                      >
                        Turn On, for 3rd Party Logistics
                      </BFormCheckbox>
                    </BFormGroup>
                  </BCol>

                  <BCol
                    cols="12"
                  >
                    <BRow>

                      <BCol
                        cols="12"
                        md="6"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="pickup_details.driver"
                          name="driver"
                          :rules="{
                            required: Number(stockRequest.pickup_details.is_3pl) === 0
                          }"
                        >
                          <BFormGroup
                            label="Driver"
                            label-for="fPickUpDriver"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <v-select
                              v-model="selected.driver"
                              input-id="fPickUpDriver"
                              placeholder="search driver here"
                              label="driver_name"
                              clearable
                              append-to-body
                              :options="(options.drivers)"
                              :loading="(fetching.drivers)"
                              :disabled="(fetching.drivers || Number(stockRequest.pickup_details.is_3pl) === 1)"
                              :calculate-position="calculateDropPosition"
                              :class="{ 'is-invalid': errors.length > 0 }"
                              @search="searchDrivers"
                            >
                              <template #option="{ driver_name }">
                                <div
                                  class="py-1"
                                  v-text="driver_name"
                                />
                              </template>
                              <template #no-options="">
                                no available driver
                              </template>
                            </v-select>
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                        md="6"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="schedule_details.vehicle"
                          name="vehicle"
                          :rules="{
                            required: Number(stockRequest.pickup_details.is_3pl) === 0
                          }"
                        >
                          <BFormGroup
                            label="Vehicle"
                            label-for="fScheduleVehicle"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <v-select
                              v-model="selected.vehicle"
                              input-id="fScheduleVehicle"
                              placeholder="search vehicle here"
                              label="vehicle_plate"
                              clearable
                              append-to-body
                              :options="(options.vehicles)"
                              :loading="(fetching.vehicles)"
                              :disabled="(fetching.vehicles || Number(stockRequest.pickup_details.is_3pl) === 1)"
                              :calculate-position="calculateDropPosition"
                              :class="{ 'is-invalid': errors.length > 0 }"
                              @search="searchVehicles"
                            >
                              <template #option="{ vehicle_plate, vehicle_name }">
                                <div class="d-flex flex-column py-1">
                                  <span
                                    class="text-wrap"
                                    v-text="vehicle_name"
                                  />
                                  <strong v-text="vehicle_plate" />
                                </div>
                              </template>
                              <template #no-options="">
                                no available vehicle
                              </template>
                            </v-select>
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                        md="3"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="pickup_details.mobile_number"
                          name="mobile number"
                          rules="required|max:11"
                        >
                          <BFormGroup
                            label="Mobile Number"
                            label-for="fScheduleMobile"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <BFormInput
                              id="fScheduleMobile"
                              v-model="stockRequest.pickup_details.mobile_number"
                              v-mask="'0##########'"
                              type="text"
                              maxlength="11"
                              :placeholder="Number(stockRequest.pickup_details.is_3pl) === 0 ? '' : 'enter mobile number here'"
                              :state="(errors.length > 0 ? false : null)"
                              :disabled="busy || Number(stockRequest.pickup_details.is_3pl) === 0"
                            />
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                        md="9"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="pickup_details.driver_name"
                          name="driver name"
                          rules="required|max:50"
                        >
                          <BFormGroup
                            label="Driver"
                            label-for="fDriver"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <BFormInput
                              id="fDriver"
                              v-model="stockRequest.pickup_details.driver_name"
                              type="text"
                              maxlength="50"
                              :placeholder="Number(stockRequest.pickup_details.is_3pl) === 0 ? '' : 'enter driver here'"
                              :state="(errors.length > 0 ? false : null)"
                              :disabled="busy || Number(stockRequest.pickup_details.is_3pl) === 0"
                            />
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>
                    </BRow>
                  </BCol>

                  <BCol
                    cols="12"
                    md="9"
                    class="px-1 px-md-2"
                    offset-md="3"
                    offset="0"
                  >
                    <ValidationProvider
                      v-slot="{ errors }"
                      vid="pickup_details.helper"
                      name="helper"
                      rules="max:50"
                    >
                      <BFormGroup
                        label="Helper"
                        label-for="fScheduleHelper"
                        label-class="font-weight-bolder"
                        class="mb-2"
                      >
                        <BFormInput
                          id="fScheduleHelper"
                          v-model="stockRequest.pickup_details.helper"
                          type="text"
                          maxlength="50"
                          :placeholder="'enter helper here ( optional )'"
                          :state="(errors.length > 0 ? false : null)"
                          :disabled="busy"
                        />
                        <div
                          v-if="(errors.length > 0)"
                          class="invalid-feedback"
                          v-text="errors[0]"
                        />
                      </BFormGroup>
                    </ValidationProvider>
                  </BCol>

                  <BCol
                    cols="12"
                  >
                    <BRow>

                      <BCol
                        cols="12"
                        md="3"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="pickup_details.vehicle_plate"
                          name="vehicle plate"
                          rules="required|max:15"
                        >
                          <BFormGroup
                            label="Vehicle Plate"
                            label-for="fScheduleVehiclePlate"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <BFormInput
                              id="fScheduleVehiclePlate"
                              v-model="stockRequest.pickup_details.vehicle_plate"
                              type="text"
                              maxlength="15"
                              :placeholder="Number(stockRequest.pickup_details.is_3pl) === 0 ? '' : 'enter plate number here'"
                              :state="(errors.length > 0 ? false : null)"
                              :disabled="busy || Number(stockRequest.pickup_details.is_3pl) === 0"
                            />
                            <div
                              v-if="(errors.length > 0)"
                              class="invalid-feedback"
                              v-text="errors[0]"
                            />
                          </BFormGroup>
                        </ValidationProvider>
                      </BCol>

                      <BCol
                        cols="12"
                        md="9"
                        class="px-1 px-md-2"
                      >
                        <ValidationProvider
                          v-slot="{ errors }"
                          vid="pickup_details.vehicle_name"
                          name="vehicle name"
                          rules="required|max:50"
                        >
                          <BFormGroup
                            label="Vehicle Name"
                            label-for="fScheduleVehicleName"
                            label-class="font-weight-bolder"
                            class="mb-2"
                          >
                            <BFormInput
                              id="fScheduleVehicleName"
                              v-model="stockRequest.pickup_details.vehicle_name"
                              type="text"
                              :placeholder="Number(stockRequest.pickup_details.is_3pl) === 0 ? '' : 'enter vehicle name here'"
                              maxlength="50"
                              :state="(errors.length > 0 ? false : null)"
                              :disabled="busy|| Number(stockRequest.pickup_details.is_3pl) === 0"
                            />
                          </BFormGroup>
                          <div
                            v-if="(errors.length > 0)"
                            class="invalid-feedback"
                            v-text="errors[0]"
                          />
                        </ValidationProvider>
                      </BCol>

                    </BRow>
                  </BCol>
                </BRow>
              </ValidationObserver>
            </BCol>
          </BRow>

        </BTab>
      </BTabs>

      <template #modal-footer="{ cancel }">
        <div class="pb-0 d-flex justify-content-between mb-0 px-0 flex-grow-1 gap-2">
          <div>
            <BButton
              v-if="editAsDraft"
              variant="secondary"
              size="sm"
              tabindex="-1"
              @click.prevent="validateRequestAsDraft"
            >
              {{ SubmitRequestAsDraftButton }}
            </BButton>
          </div>
          <div class="d-flex gap-2">
            <BButton
              variant="primary"
              size="sm"
              tabindex="-1"
              @click.prevent="validateRequest"
            >
              Submit <span class="d-none d-md-inline-block">Withdrawal</span>
            </BButton>
            <BButton
              variant="outline-dark"
              size="sm"
              tabindex="-1"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Discard
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

    <BModal
      id="modalRequestPreview"
      size="xl"
      scrollable
      centered
      hide-header
      no-enforce-focus
      no-close-on-backdrop
      content-class="scrollable-tabs"
      modal-class="full-height modal-no-padding"
      aria-hidden="false"
      role="dialog"
    >
      <BTabs
        active-nav-item-class="font-weight-bold text-uppercase text-primary"
        content-class="scrollable"
      >
        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-list-tree mr-1" />
              <b class="is-tab-active">Products</b>
            </div>
          </template>

          <BRow
            class="mx-0 mt-1 mb-0"
          >
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>
                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Transaction Number"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.references.transaction_number"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Withdrawal Type"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.headers.withdrawal_type"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Withdrawal To"
                    class="mb-2"
                  >
                    <strong
                      v-if="['Warehouse', 'Others'].includes(stockRequest.headers.withdrawal_type)"
                      v-text="stockRequest.headers.destination_name"
                    />
                    <strong
                      v-else
                      v-text="stockRequest.headers.supplier_name"
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Remarks"
                    class="mb-2"
                  >
                    <strong
                      v-text="stockRequest.remarks || 'no remarks'"
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>

            <BCol
              cols="12"
              class="px-0 px-md-1"
            >
              <BTable
                ref="tableProducts"
                small
                hover
                striped
                bordered
                responsive
                show-empty
                class="mb-0"
                :stacked="tableProducts.stacked"
                :items="stockRequest.details"
                :fields="tableProducts.fields"
                :filter="tableProducts.filter"
                :filter-included-fields="tableProducts.filterOn"
                :busy="tableProducts.busy"
              >
                <template #cell(index)="{ index }">
                  <div
                    class="text-md-nowrap d-flex justify-content-center align-items-centermin-h-35px"
                    v-text="tableRowNumber(tableProducts, index)"
                  />
                </template>

                <template #cell(product_name)="{ value }">
                  <div class="text-md-nowrap d-flex align-items-center min-h-35px px-1">
                    <span
                      v-text="value"
                    />
                  </div>
                </template>

                <template #cell(quantity)="{ value }">
                  <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                    <strong
                      class="font-weight-bolder"
                      v-text="numberFormatter(value, '0,0')"
                    />
                  </div>
                </template>

                <template #cell(approved_quantity)="{ value, item }">
                  <div class="text-md-nowrap d-flex justify-content-center align-items-center min-h-35px">
                    <strong
                      :class="['font-weight-bolder', {
                        'text-danger': Number(value) <= 0,
                        'text-warning': Number(value) >= 1 && Number(item.quantity) !== Number(value),
                        'text-success': Number(item.quantity) === Number(value)
                      }]"
                      v-text="numberFormatter(value, '0,0')"
                    />
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center py-5">
                    <BIcon
                      icon="stopwatch"
                      font-scale="5"
                      animation="cylon"
                    />
                    <p class="h3 py-2">
                      <strong>Loading . . .</strong>
                    </p>
                  </div>
                </template>

              </BTable>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-file-lines mr-1" />
              <b class="is-tab-active">Withdrawal Details</b>
            </div>
          </template>

          <BRow
            class="mx-0 mt-1 mb-0"
          >
            <BCol
              cols="12"
              class="px-1 px-md-2"
            >
              <BRow>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Delivery Date"
                    label-for="fvScheduleDate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDate"
                      v-model="stockRequest.pickup_details.date"
                      type="date"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Logistics Type"
                    label-for="fvPickUpLogisticsType"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvPickUpLogisticsType"
                      v-model="stockRequest.pickup_details.logistics_type"
                      type="text"
                      maxlength="25"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol cols="12" />

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Mobile Number"
                    label-for="fvScheduleMobile"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleMobile"
                      v-model="stockRequest.pickup_details.mobile_number"
                      type="text"
                      maxlength="50"
                      placeholder="no mobile number"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Driver"
                    label-for="fvScheduleDriver"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleDriver"
                      v-model="stockRequest.pickup_details.driver_name"
                      type="text"
                      maxlength="50"
                      placeholder="no driver"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                  offset-md="3"
                  offset="0"
                >
                  <BFormGroup
                    label="Helper"
                    label-for="fvScheduleHelper"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleHelper"
                      v-model="stockRequest.pickup_details.helper"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="3"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Plate"
                    label-for="fvScheduleVehiclePlate"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleVehiclePlate"
                      v-model="stockRequest.pickup_details.vehicle_plate"
                      type="text"
                      maxlength="25"
                      placeholder="no vehicle plate"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

                <BCol
                  cols="12"
                  md="9"
                  class="px-1 px-md-2"
                >
                  <BFormGroup
                    label="Vehicle Name"
                    label-for="fvScheduleVehicleName"
                    label-class="font-weight-bolder"
                    class="mb-2"
                  >
                    <BFormInput
                      id="fvScheduleVehicleName"
                      v-model="stockRequest.pickup_details.vehicle_name"
                      type="text"
                      maxlength="50"
                      placeholder="no helper"
                      disabled
                    />
                  </BFormGroup>
                </BCol>

              </BRow>
            </BCol>
          </BRow>
        </BTab>

        <BTab class="p-2 py-4">
          <template #title>
            <div class="text-md-nowrap">
              <i class="fa-lg fad fa-timeline-arrow mr-1" />
              <b class="is-tab-active ml-1">Tracking</b>
            </div>
          </template>

          <BContainer>
            <Timeline
              :stock-request="stockRequest"
            >
              <template #approvals="request">
                <Signatory
                  :stock-request="request"
                  :approver="requesterSignatory"
                />
                <Signatory
                  v-if="['Canceled'].includes(canceledSignatory.status)"
                  :stock-request="request"
                  :approver="canceledSignatory"
                />
                <Signatory
                  v-for="(approver, key) in request.approvals"
                  :key="key"
                  :stock-request="request"
                  :approver="approver"
                />
              </template>
            </Timeline>
          </BContainer>
        </BTab>

      </BTabs>
      <template #modal-footer="{ cancel }">
        <div class="col-12 pb-0 d-flex justify-content-end mb-0 px-0">
          <div>
            <BButton
              size="sm"
              variant="outline-dark"
              tabindex="-1"
              @click.prevent="$event => {
                $event.target.blur()
                cancel()
              }"
            >
              Close <span class="d-none d-md-inline-block">Window</span>
            </BButton>
          </div>
        </div>
      </template>
    </BModal>

  </BContainer>
</template>
<script>
import QUERY from 'lodash'
import { mapGetters } from 'vuex'

import MISC from '@/mixins/misc'
import FORMATTER from '@/mixins/formatter'

import MDrivers from '@/mixins/maintenances/drivers'
import MVehicles from '@/mixins/maintenances/vehicles'
import MProducts from '@/mixins/maintenances/products'
import MDestinations from '@/mixins/locations/destinations'
import MSuppliers from '@/mixins/accounts/suppliers'
import MStocks from '@/mixins/maintenances/stocks'

import MCreate from '@/views/lo/atws/withdrawals/mixins/create'
import MDraft from '@/views/lo/atws/withdrawals/mixins/draft'
import MPreview from '@/views/lo/atws/withdrawals/mixins/preview'

import RequestPending from '@/views/lo/atws/withdrawals/Pending.vue'
import RequestDraft from '@/views/lo/atws/withdrawals/Draft.vue'
import RequestHistory from '@/views/lo/atws/withdrawals/History.vue'

import POTable from '@/components/tables/POTable.vue'

import Timeline from '@/components/custom/timeline/Base.vue'
import Signatory from '@/components/custom/timeline/Signatory.vue'

export default {

  name: 'VLOAtwTransfer',

  middleware: ['auth', 'lo'],

  metaInfo: () => ({
    title: 'ATW Transfers'
  }),

  components: {
    RequestPending,
    RequestDraft,
    RequestHistory,
    POTable,
    Timeline,
    Signatory
  },

  mixins: [
    MISC,
    FORMATTER,
    MDrivers,
    MVehicles,
    MProducts,
    MDestinations,
    MSuppliers,
    MStocks,
    MCreate,
    MDraft,
    MPreview
  ],

  data () {
    return {
      busy: false,
      editing: false,
      editAsDraft: true,
      currentTabIndex: this.getCurrentTabIndexByURL(),
      options: {
        withdrawalTypes: [
          'Warehouse',
          'Others',
          'Supplier'
        ]
      },
      selected: {
        locationType: 'Warehouse',
        allowIn: '',
        allowOut: 1
      },
      editable: {
        is3pl: ''
      },
      stockRequest: {
        id: '',
        stage: 0,
        references: {
          document_number: '',
          transfer_number: '',
          sap_doc_entry: '',
          transaction_number: ''
        },
        headers: {
          withdrawal_type: '',
          destination: '',
          destination_name: '',
          destination_code: '',
          supplier: '',
          supplier_name: '',
          supplier_code: ''
        },
        pickup_details: {
          date: '',
          vehicle: '',
          vehicle_plate: '',
          vehicle_name: '',
          driver: '',
          driver_name: '',
          mobile_number: '',
          logistics_type: 'In-House',
          is_3pl: 0,
          helper: ''
        },
        details: [],
        approvals: [],
        created_at: ''
      },
      tableProducts: {
        selected: {
          details: [],
          allSelected: false,
          indeterminate: false
        },
        busy: false,
        filter: {
          search: ''
        },
        filterOn: [],
        stacked: this.isMobile(),
        sortBy: 'id',
        sortDesc: false,
        sortDirection: 'asc',
        pageOptions: [10, 25, 50, 100],
        currentPage: 1,
        totalRows: 0,
        perPage: 10,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 1, key: 'product_name', class: 'min-w-200px' },
          { mobile: 2, key: 'quantity', class: ['text-center', { 'col-2': !this.isMobile() }] }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  watch: {

    'selected.locationType' (locationType) {
      this.stockRequest.headers.withdrawal_type = locationType || ''
    },

    'stockRequest.headers.withdrawal_type' (withdrawalType) {
      if (withdrawalType) {
        if (withdrawalType === 'Supplier') {
          this.getSuppliers(this).finally(() => {
            if (this.editable.supplier) {
              this.selected.supplier = QUERY.find(this.options.suppliers, {
                id: this.editable.supplier
              }) || ''

              this.editable.supplier = ''
            }
          })
        } else {
          this.getDestinations(this).finally(() => {
            if (this.editable.destination) {
              this.selected.destination = QUERY.find(this.options.destinations, {
                id: this.editable.destination
              }) || ''

              this.editable.destination = ''
            }
          })
        }
      } else {
        this.selected.destination = ''
        this.selected.supplier = ''
      }
    },

    'selected.destination' (destination) {
      this.stockRequest.headers.destination = destination?.id || ''
      this.stockRequest.headers.destination_code = destination?.location_code || ''
      this.stockRequest.headers.destination_name = destination?.location_name || ''

      this.stockRequest.headers.supplier = ''
      this.stockRequest.headers.supplier_code = ''
      this.stockRequest.headers.supplier_name = ''
    },

    'selected.supplier' (supplier) {
      this.stockRequest.headers.supplier = supplier?.id || ''
      this.stockRequest.headers.supplier_code = supplier?.supplier_code || ''
      this.stockRequest.headers.supplier_name = supplier?.supplier_name || ''

      this.stockRequest.headers.destination = ''
      this.stockRequest.headers.destination_code = ''
      this.stockRequest.headers.destination_name = ''
    },

    'stockRequest.pickup_details.is_3pl' (is3pl) {
      if (['0', '1'].includes(String(this.editable.is3pl))) {
        this.editable.is3pl = ''
      } else {
        this.stockRequest.pickup_details.driver = ''
        this.stockRequest.pickup_details.driver_name = ''
        this.stockRequest.pickup_details.mobile_number = ''

        this.stockRequest.pickup_details.vehicle = ''
        this.stockRequest.pickup_details.vehicle_plate = ''
        this.stockRequest.pickup_details.vehicle_name = ''

        if (Number(is3pl) === 1) {
          this.selected.driver = ''
          this.options.drivers = []

          this.selected.vehicle = ''
          this.options.vehicles = []
        } else {
          this.getDrivers(this)
          this.getVehicles(this)
        }
      }
    },

    'selected.driver' (driver) {
      this.stockRequest.pickup_details.driver = driver?.id || ''
      this.stockRequest.pickup_details.driver_name = driver?.driver_name || ''
      this.stockRequest.pickup_details.mobile_number = driver?.mobile_number || ''
    },

    'selected.vehicle' (vehicle) {
      this.stockRequest.pickup_details.vehicle = vehicle?.id || ''
      this.stockRequest.pickup_details.vehicle_plate = vehicle?.vehicle_plate || ''
      this.stockRequest.pickup_details.vehicle_name = vehicle?.vehicle_name || ''
    }
  },

  methods: {

    getCurrentTabIndexByURL () {
      switch (this.$route.params.withdrawer) {
        case 'histories' : {
          return 2
        }
        case 'drafts' : {
          return 1
        }
        default: {
          return 0
        }
      }
    },

    validateRequest () {
      this.$refs.formStockRequest.validate().then(
        validStockRequest => {
          this.$refs.formProducts.validate().then(
            validProduct => {
              this.$refs.formWithdrawal.validate().then(
                validWithdrawal => {
                  if (!validStockRequest || !validProduct || !validWithdrawal) {
                    return this.swalInvalid()
                  }

                  this.swalConfirmWithRemarks({
                    html: () => {
                      if (this.editing && this.editAsDraft) {
                        return '<h6>Submit Draft as Authority to Withdraw?</h6>'
                      }

                      return '<h6>Submit Authority to Withdraw?</h6>'
                    },
                    remarksRequired: true,
                    remarksMaxLength: 220,
                    preConfirm: remarks => {
                      if (this.editing && this.editAsDraft) {
                        return this.updateDraft(0, remarks)
                      }

                      return this.submitRequest(remarks)
                    },
                    confirmButtonText: 'Submit'
                  })
                }
              )
            })
        })
    },

    setProductErrors (errors) {
      const mappedErrors = {}

      Object.keys(errors).forEach(error => {
        const splitted = error.split('.')
        if (splitted.length > 0) {
          const productFields = [
            'category_code',
            'category_name',
            'product_code',
            'product_name',
            'group_code',
            'group_name'
          ]

          if (splitted[0] === 'details' && productFields.includes(splitted[splitted.length - 1])) {
            mappedErrors[`details.${splitted[1]}.product`] = errors[error]
          } else {
            mappedErrors[error] = errors[error]
          }
        }
      })

      this.$refs.formProducts.setErrors(mappedErrors)
    }
  }
}
</script>
